export default [
    {
        path: '/xiangmu',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/xiangmu.vue'),

    },
    {
        path: '/xiangmu/pm',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/pm.vue'),
        meta: {keepAlive:true, title: '项目列表',
            isTabsPage: true
        }
    },
    //未闭环内销修改页面
    {
        path: '/xiangmu/nxedit',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/nxedit.vue'),
    },
    {
        path: '/xiangmu/xmxunjbaojzdgys',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/xmxunjbaojzdgys.vue'),
    },
    {
        path: '/xiangmu/pmgys',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/pmgys.vue'),
        meta: {
            title: '报价管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        //新建项目
        path: '/xiangmu/newProject',
        component: () => import( '@/views/loud/xiangmu/newProject.vue'),

    },
    {
        //新建项目
        path: '/xiangmu/newProject2',
        component: () => import( '@/views/loud/xiangmu/newProject2.vue'),
    },
    {
        path: '/xiangmu/Pdetails',
        component: () => import( '@/views/loud/xiangmu/Pdetails.vue'),
        meta: {
            title: '项目详情',
            requireAuth: true
        }
    },
    {
        //采购项目修改详情
        path: '/xiangmu/CGdetails',
        component: () => import( '@/views/loud/xiangmu/CGdetails.vue'),
        meta: {
            title: '项目详情',
            requireAuth: true
        }
    },
    {
        path: '/xiangmu/Earnings',
        component: () => import( '@/views/loud/xiangmu/Earnings.vue'),
        meta: {
            title: '盈利测算',
            requireAuth: true
        }
    },
    {
        path: '/xiangmu/EarningsCopy',
        component: () => import( '@/views/loud/xiangmu/EarningsCopy.vue'),
    },
    {
        path: '/xiangmu/enter',
        component: () => import( '@/views/loud/xiangmu/enter.vue'),
    },
    {
        path: '/xiangmu/marketEnter',
        component: () => import( '@/views/loud/xiangmu/marketEnter')
    },
    {
        path: '/xiangmu/financeE',
        component: () => import( '@/views/loud/xiangmu/financeE')
    },
    {
        path: '/xiangmu/marketSell',
        component: () => import( '@/views/loud/xiangmu/marketSell')
    },
    {
        //报价单
        path: '/xiangmu/quotationOfprices',
        component: () => import( '@/views/loud/xiangmu/quotationOfprices')
    },
    {
        path: '/xiangmu/commit',
        component: () => import( '@/views/loud/xiangmu/commit')
    },
    {
        path: '/xiangmu/commitsh',
        component: () => import( '@/views/loud/xiangmu/commitsh')
    },
    {
        path: '/xiangmu/initiate',
        component: () =>import ( '@/views/loud/xiangmu/initiate')
    },
    {

        path: '/xiangmu/sponsorE',
        component: () =>import ( '@/views/loud/xiangmu/sponsorE')

    },
    {
        path: 'xiangmu/change-market',
        component: () =>import ( '@/views/loud/xiangmu/change-market')
    },
	//历史报价库
	{
	    path: 'xiangmu/historyPrice',
	    component: () =>import ( '@/views/loud/xiangmu/historyPrice')
	},
	{
		//新建项目弹窗
		path: '/xiangmu/createXiangmu',
		component: () => import( '@/views/loud/xiangmu/createXiangmu.vue'),
        meta: {
            title: '新建项目',
            isTabsPage: true,
            keepAlive:true
        }
	},
    {
        //项目报价
        path: '/xiangmu/offerManage',
        component: () => import( '@/views/loud/xiangmu/offerManage.vue'),
        meta: {
            title: '项目报价',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/xiangmu/xmxunjbaojzdgys2',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/xmxunjbaojzdgys2.vue'),
    },
    {
        path: '/xiangmu/cgDetail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/xiangmu/cgDetail.vue'),
    },
    {
        path: '/xiangmu/projectUserReport',
        component:()=>import('@/views/loud/xiangmu/projectUserReport.vue'),
        meta: {
            title: '项目关联用户报表',
            isTabsPage: true,
            keepAlive:true
        }
    },
]
